
// import store from '@/store';
import App from "./App.vue"
import '@/style/global.less';
import i18n from '@/locales/useI18n'
import 'virtual:svg-icons-register';
import setupDefaultSetting from '@/utils/setupDefaultSetting'
import config from '@/config/defaultSettings'
import 'ant-design-vue/dist/reset.css'
import "video.js/dist/video-js.css";
import "@/utils/default-passive-events"
import createDynamicComponentResolver from '@/utils/LoadDynamic'
import ComCommon from './components' // 封装组件

import { createBaseSystem } from '@admin-base/core'
import "@admin-base/core/dist/style.css"
import { example } from "@/router/commonRoutes"

import * as adminUI from "@admin-base/ui"
import "@admin-base/ui/dist/style.css"

const { app, mount } = createBaseSystem({
    App,
    router: { routes: example, mode: 'hash' },
    i18n,
    name: config.storage.namespace,
    // storage: config,
    //@ts-ignore
    namespace: "operations",
    terminal: 'operations',
    // api: { baseURL: 'https://api.example.com' },
    resolver: createDynamicComponentResolver()
})
for (const key in adminUI) {
    app.component(key, adminUI[key])
}
mount('#app')
app.use(ComCommon)


setupDefaultSetting()

window.env = import.meta.env.MODE
window.log = console.log
